<template>
<createUser/>
</template>

<script>
import createUser from "@/components/AdminComponents/createUser";

export default {
  name: "adminHomePage",
  components: {
    createUser
  }
}
</script>

<style scoped>

</style>